import { performRequest } from 'common/utils/performRequest';
import {
  GET_USER_DETAILS_FAILURE,
  GET_USER_DETAILS_REQUEST,
  GET_USER_DETAILS_SUCCESS,
} from 'reducers/login-reducer';

export const GET_USER_URL = '/api/gateway/v1/user';

export default function getUserDetail() {
  return async dispatch => {
    dispatch({ type: GET_USER_DETAILS_REQUEST });
    try {
      const response = await performRequest('post', GET_USER_URL, {});

      dispatch({
        type: GET_USER_DETAILS_SUCCESS,
        payload: response.data.userDetails,
      });
    } catch (err) {
      dispatch({ type: GET_USER_DETAILS_FAILURE, payload: err.response.data });
    }
  };
}
